import { TranslateFn } from '@react/gettext';

/** Číselník důvodů vrácení – kódy se ukládají do VRATKY.duvod_vraceni */
export function reasonLabel(t: TranslateFn, code: string): string {
    const labels: Record<string, string> = {
        '14_dni': t('Bez důvodu do 14ti dní (pouze koncový zákazník)'),
        poskozeno_preprava: t('Poškozeno při přepravě'),
        chyba_bola: t('Chyba na straně BOLA spol s.r.o.'),
        chyba_zakaznik: t('Chyba na straně zákazníka'),
        jiny: t('Jiný'),
        reklamace: t('Reklamace'),
    };

    return labels[code] ?? code;
}
